import React from 'react'
import Accordion from 'react-bootstrap/Accordion';
import { StaticImage } from 'gatsby-plugin-image';
import parser from 'html-react-parser'

export default function Faq({data}) {
    const {faqContactEmail, faqContactEmailText, faqTitle, faqContactText, faqFaqs} = data
    return (
        <section className='ourworkfaq-wrap'>
            <div className='container'>
                <div className='row'>
                    <div className='co-md-12 text-center'>
                        <figure className='abt-origins-icon'>
                            <StaticImage src='../../../images/origins-icon.png' alt='image' />
                        </figure>
                        <h2 className='heading-level-2 blue-color'>{faqTitle && parser(faqTitle)}</h2>
                    </div>
                    <div className='co-md-12'>
                        <Accordion>
                            {faqFaqs?.map((faq, i) => (
                                <Accordion.Item eventKey={i} key={i}>
                                    <Accordion.Header>{faq.faqQuestion && parser(faq.faqQuestion)}</Accordion.Header>
                                    <Accordion.Body>
                                        {faq.faqAnswer && parser(faq.faqAnswer)}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </div>
                    <div className='col-md-12 text-center faq-btm-footer'>
                        <h3 className='heading-level-3 black-color'>{faqContactText && parser(faqContactText)}</h3>
                        <p>
                            {faqContactEmailText}{' '}
                            <a href={`mailto:${faqContactEmail}`}>{faqContactEmail}</a>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}
